import { extend, localize, ValidationObserver, ValidationProvider } from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";
import { between, confirmed, email, max, min, regex, required } from "vee-validate/dist/rules";
import Vue from "vue";

import { englishMessages, spanishMessages } from "@/locale/languages";
import { Locale } from "@/locale/Locale";

import { ValidationType } from "./ValidationType";

export function configureValidation(): void {
    // Adding the default vee-validate locale messages first,
    // then our explicit locale messages, overriding the defaults if they match:
    localize({
        [Locale.English]: {
            messages: {
                ...en.messages,
                ...englishMessages.validation
            }
        },
        [Locale.Spanish]: {
            messages: {
                ...es.messages,
                ...spanishMessages.validation
            }
        }
    });

    // add validation rules
    extend(ValidationType.required, required);
    extend(ValidationType.minimum, min);
    extend(ValidationType.maximum, max);
    extend(ValidationType.between, between);
    extend(ValidationType.email, email);
    extend(ValidationType.confirmed, confirmed);
    extend(ValidationType.regex, regex);

    // the built-in "is" rule uses strict equality, so we need to override it
    extend(ValidationType.is, {
        // eslint-disable-next-line eqeqeq
        validate: (value: string | boolean) => value == true
    });

    // dummy validators for property info
    extend("displayName", {
        validate: () => true
    });
    extend("propertyName", {
        validate: () => true
    });

    // add components
    Vue.component("validation-provider", ValidationProvider);
    Vue.component("validation-observer", ValidationObserver);
}
